import classNames from 'classnames';
import CustomField from './CustomField';
import React from 'react';
import PropTypes from 'prop-types';

import './styles/gender_field.scss';
import registeredComponent from "utils/registeredComponent";

class GenderField extends React.Component {

  /**
   * propTypes
   * String props passed from the view partial (_gender_field_edit)
   * name - Name of the form the component is on, used to build a concatenated string field name
   * map_to - Mapping of the field on the form
   * gender - Current value for gender, used to prepopulate for adhoc forms
   * genderDisplay -  Current value for gender, used to prepopulate for adhoc forms
   * pronoun -  Current value for gender, used to prepopulate for adhoc forms
   *    */

  static propTypes = {
    name: PropTypes.string,
    map_to: PropTypes.string,
    gender:  PropTypes.string,
    genderDisplay:  PropTypes.string,
    pronoun:  PropTypes.string,
    required: PropTypes.bool,
    genderConfig: PropTypes.object,
    errors: PropTypes.object
  };

  static defaultProps = {
    gender:  "",
    genderDisplay:  "",
    pronoun:  "",
    genderConfig: {}
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {gender: this.props.gender, genderDisplay: this.props.genderDisplay, pronoun: this.props.pronoun};
  }

  render() {
    const {gender, genderDisplay, pronoun} = this.state;
    const {errors, required, genderConfig} = this.props;
    return (
      <React.Fragment>
        <div className="gender-display">
          <Gender answer={gender}
                  field={this.fieldName('gender')}
                  genderConfig={genderConfig}
                  handleChange={this.handleChange}>

           <GenderDisplay gender={gender}
                          answer={genderDisplay}
                          field={this.fieldName('gender_display')}
                          handleChange={this.handleChange}
                          hasError={errors.gender_display}/>
          </Gender>
        </div>

          <Pronoun gender={gender}
                   answer={pronoun}
                   field={this.fieldName('preferred_pronoun')}
                   handleChange={this.handleChange}
                   genderConfig={genderConfig}
                   hasError={errors.preferred_pronoun}
                   required={required}/>

      </React.Fragment>
    );
  }

  fieldName(fieldname) {
    const {name, map_to} = this.props;
    return `${name}[${map_to}${fieldname}]`
  }

  handleChange(e, field) {
    this.setState({[field]: e.target.value})

  }

}

const Gender = (props) => {
    const {answer, field, handleChange, genderConfig} = props;

    return (
      <span>
        {genderConfig.gender_options.map((option) => option !== 'O' ?
          <span className='gender-option-spacing'>
            <input className="sa-form-trigger"
                   name={field}
                   type="radio"
                   value={option}
                   onChange={(e) => handleChange(e, 'gender')}
                   id={"gender_" + genderConfig.gender_map[option].toLowerCase()}
                   checked={answer === option}/>
                    <span className='gender-label'>{genderConfig.gender_map[option]}</span>
        </span> :
          <span className='gender-option-spacing'>
              <input className="sa-form-trigger"
                     name={field}
                     type="radio"
                     value="O"
                     onChange={(e) => handleChange(e, 'gender')}
                     id="gender_open"
                     checked={answer === "O"}/>
            {props.children}
        </span>
        )}
      </span>
    )
};

const GenderDisplay = (props) => {
    const {gender, field, answer, handleChange, hasError, genderConfig} = props;
    const disable = gender !== 'O';
    return (
      <span className='gender-label'>
        <input className={classNames("border-1", {"sa-form-error-field": hasError && !disable})}
               name={field}
               type="text"
               placeholder="Self-Identify"
               onChange={(e) => handleChange(e, 'genderDisplay')}
               disabled={disable}
               style={{width: '160px'}}
               value={answer}/>
        {/* Handles stripping the value if the Open value is not selected */}
        {disable && <input type="hidden" name={field} value=""/>}
      </span>
    );
};

const Pronoun = (props) => {
  const {gender, field, handleChange, answer, genderConfig, required, hasError = false} = props;
  const binaryDefault = (gender) => {
    if (gender === 'M' || gender === 'F') {
      return gender
    }
  }
  const defaultAnswer = answer || binaryDefault(gender);
  const fieldRequired = genderConfig.require_pronouns && required;
  const pronounMap = genderConfig.pronoun_map;
  if (genderConfig.allow_pronouns) {
    return (
      <div>
        <label
          className={`form-label align-self-start pronoun-label ${fieldRequired ? 'sa-form-required-field required' : ""} ${hasError ? 'sa-form-error-field-label' : ''}`}>Pronouns</label>
        <CustomField.Subfield
          dataFlavor="gender.preferred_pronoun"
          name={field}
          hasError={hasError}>
          <select name={field}
                  className={classNames({"sa-form-error-field": hasError})}
                  onChange={(e) => handleChange(e, 'pronoun')}
                  value={defaultAnswer}>
            <option value=""/>
            {Object.keys(pronounMap).map((value) =>
              <option value={value}>{pronounMap[value]}</option>
            )}

          </select>
        </CustomField.Subfield>
      </div>
    );
  } else {
    // No-op
    return (<span/>);
  }
};


export default registeredComponent("GenderField")(GenderField);
